import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16;

import { useCallback, useEffect, useMemo, useRef } from 'react';
import styled from '@xstyled/styled-components';
import { AudioPlayer, styleVariables, EditorCommentViewOnly, EditorComment, getColor, getSize } from '@lib/common';
import { Space } from 'antd';
import { BaseQuestionGradingComponent } from '../../../bases';
import { InfoCircleOutlined, HighlightOutlined, MessageOutlined } from '@ant-design/icons';
import { EmptyAnswerLabel, countWords, hasEssayContent } from './components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledSpaceContainer = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var StyledAudioPlayerContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n"])), getSize('gap8'));
var StyledEditorSection = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var StyledStudentWorkHeader = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: ", ";\n  justify-content: space-between;\n  width: 100%;\n"])), getSize('gap12'));
var StyledSectionLabel = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n  margin-right: ", ";\n"])), getSize('typo16'), styleVariables.font.fontWeightStrong, getSize('gap4'));
var StyledAnswerContainer = styled(Space)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var StyledAnswerSurface = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 100%;\n  overflow: hidden;\n  border: 2px solid #c7d5e7;\n  border-radius: ", ";\n  background: ", ";\n  box-shadow: 0 2px 6px ", ";\n\n  .tiptap {\n    margin-bottom: 0 !important;\n  }\n\n  .ProseMirror {\n    min-height: 160px;\n    padding: ", " !important;\n    border: none !important;\n    border-radius: 0 !important;\n    font-size: ", ";\n    line-height: 1.65;\n  }\n"])), getSize('gap12'), getColor('fillBgWhite'), styleVariables.colors.transparentGray6, getSize('padding24'), getSize('typo16'));
var StyledEmptyAnswerSurface = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 200px;\n  padding: ", ";\n  border: 2px solid #c7d5e7;\n  border-radius: ", ";\n  background: ", ";\n  box-shadow: 0 2px 6px ", ";\n"])), getSize('padding24'), getSize('gap12'), getColor('fillBgWhite'), styleVariables.colors.transparentGray6);
var StyledCountGroup = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: ", ";\n"])), getSize('gap8'));
var StyledCountBadge = styled.span(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: ", ";\n  min-height: 32px;\n  padding: ", " ", ";\n  border-radius: ", ";\n  background: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  font-variant-numeric: tabular-nums;\n"])), getSize('gap4'), getSize('gap4'), getSize('gap12'), getSize('gap12'), getColor('fillIconBgDefault'), getColor('textIntDefault'), getSize('typo14'), styleVariables.font.fontWeightStrong);
var StyledHighlightGuideBox = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", ";\n  padding: ", ";\n  margin-bottom: ", ";\n"])), getColor('fillIconBgDefault'), getSize('gap8'), getSize('padding8'), getSize('gap16'));
var StyledHighlightGuideHeaderRow = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));
var StyledHighlightGuideTitleGroup = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"])));
var StyledHighlightGuideTitleText = styled.span(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n"])), getSize('typo14'), styleVariables.font.fontWeightStrong, getColor('textIntDefault'));
var StyledHighlightGuideStepList = styled.ol(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  margin: ", " 0 0 0;\n  padding-left: ", ";\n  font-size: ", ";\n  color: ", ";\n"])), getSize('gap8'), getSize('gap24'), getSize('typo14'), getColor('textIntDefault'));
var StyledHighlightGuideStep = styled.li(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n"])), getSize('gap4'));
export var EssayGradingComponent = function EssayGradingComponent(_ref) {
  var _answer$value2, _answer$answerComment, _answer$value3, _answer$value3$audioF, _answer$answerComment4, _comments$length;

  var states = _ref.states,
      actions = _ref.actions;
  var baseLabel = states.label,
      answer = states.answer,
      comments = states.comments,
      setComments = states.setComments,
      disabled = states.disabled,
      loadingComment = states.loadingComment;
  var label = baseLabel;
  var onAnswerComment = actions.onAnswerComment,
      onUpdateAnswerComment = actions.onUpdateAnswerComment,
      onDeleteAnswerComment = actions.onDeleteAnswerComment,
      onClickAnswer = actions.onClickAnswer;
  var shouldShowHighlightGuide = useMemo(function () {
    var _answer$value;

    return !!(onAnswerComment && onUpdateAnswerComment && onDeleteAnswerComment && setComments) && !(answer !== null && answer !== void 0 && answer.isEmpty() || !(answer !== null && answer !== void 0 && (_answer$value = answer.value) !== null && _answer$value !== void 0 && _answer$value.text)) && !!label.highlightGuideTitle;
  }, [onAnswerComment, onUpdateAnswerComment, onDeleteAnswerComment, setComments, answer, label.highlightGuideTitle]);
  var editorCommentLabels = useMemo(function () {
    return {
      save: label.save,
      cancel: label.cancel,
      comment: label.comment,
      selectColor: label.selectColor,
      enterComment: label.enterComment,
      edit: label.edit,
      "delete": label["delete"],
      shortcutToSave: label.commentShortcutToSave
    };
  }, [label.save, label.cancel, label.comment, label.selectColor, label.enterComment, label.edit, label["delete"], label.commentShortcutToSave]);
  var handleClickAnswer = useCallback(function () {
    if (onClickAnswer && answer !== null && answer !== void 0 && answer.id) {
      onClickAnswer(answer.id.toString());
    }
  }, [onClickAnswer, answer === null || answer === void 0 ? void 0 : answer.id]);
  var responderAnswerContent = (answer === null || answer === void 0 ? void 0 : (_answer$value2 = answer.value) === null || _answer$value2 === void 0 ? void 0 : _answer$value2.text) || '';
  var answerContent = (answer === null || answer === void 0 ? void 0 : (_answer$answerComment = answer.answerComment) === null || _answer$answerComment === void 0 ? void 0 : _answer$answerComment.submissionAnswerContent) || responderAnswerContent;
  var hasTextAnswer = hasEssayContent(answerContent);
  var audioSource = answer === null || answer === void 0 ? void 0 : (_answer$value3 = answer.value) === null || _answer$value3 === void 0 ? void 0 : (_answer$value3$audioF = _answer$value3.audioFile) === null || _answer$value3$audioF === void 0 ? void 0 : _answer$value3$audioF.url;
  var hasAudioAnswer = Boolean(audioSource);
  var initializedAnswerIdRef = useRef(null);
  var savedComments = useMemo(function () {
    var _answer$answerComment2, _answer$answerComment3;

    return (answer === null || answer === void 0 ? void 0 : (_answer$answerComment2 = answer.answerComment) === null || _answer$answerComment2 === void 0 ? void 0 : (_answer$answerComment3 = _answer$answerComment2.comments) === null || _answer$answerComment3 === void 0 ? void 0 : _answer$answerComment3.map(function (comment) {
      return {
        id: comment.id.toString(),
        content: comment.content
      };
    })) || [];
  }, [answer === null || answer === void 0 ? void 0 : (_answer$answerComment4 = answer.answerComment) === null || _answer$answerComment4 === void 0 ? void 0 : _answer$answerComment4.comments]);
  useEffect(function () {
    var _answer$id;

    var answerId = (answer === null || answer === void 0 ? void 0 : (_answer$id = answer.id) === null || _answer$id === void 0 ? void 0 : _answer$id.toString()) || null;

    if (shouldShowHighlightGuide && answerId && initializedAnswerIdRef.current !== answerId) {
      setComments === null || setComments === void 0 ? void 0 : setComments(savedComments);
      initializedAnswerIdRef.current = answerId;
    }
  }, [answer === null || answer === void 0 ? void 0 : answer.id, shouldShowHighlightGuide, savedComments, setComments]);

  var renderAnswer = function renderAnswer() {
    var _answer$answerComment5, _answer$answerComment6;

    if (!hasTextAnswer && !hasAudioAnswer) {
      return /*#__PURE__*/_jsx(StyledEmptyAnswerSurface, {
        children: /*#__PURE__*/_jsx(EmptyAnswerLabel, {
          children: label.noAnswerSubmitted
        })
      });
    }

    if (shouldShowHighlightGuide) {
      var _answer$value4;

      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(StyledAnswerContainer, {
          direction: "vertical",
          onClick: handleClickAnswer,
          children: /*#__PURE__*/_jsx(StyledAnswerSurface, {
            children: /*#__PURE__*/_jsx(StyledEditorSection, {
              children: /*#__PURE__*/_jsx(EditorComment, {
                onAnswerComment: onAnswerComment,
                content: answerContent,
                onUpdateAnswerComment: onUpdateAnswerComment,
                onDeleteAnswerComment: onDeleteAnswerComment,
                showComment: true,
                comments: comments,
                setComments: setComments,
                labels: editorCommentLabels,
                scrollable: true,
                loadingComment: loadingComment
              })
            })
          })
        }), (answer === null || answer === void 0 ? void 0 : (_answer$value4 = answer.value) === null || _answer$value4 === void 0 ? void 0 : _answer$value4.audioFile) && /*#__PURE__*/_jsx(AudioPlayer, {
          source: answer.value.audioFile.url
        })]
      });
    }

    return /*#__PURE__*/_jsxs(StyledAnswerContainer, {
      direction: "vertical",
      children: [hasTextAnswer && /*#__PURE__*/_jsx(StyledAnswerSurface, {
        children: /*#__PURE__*/_jsx(StyledEditorSection, {
          children: /*#__PURE__*/_jsx(EditorCommentViewOnly, {
            content: answerContent,
            comments: (answer === null || answer === void 0 ? void 0 : (_answer$answerComment5 = answer.answerComment) === null || _answer$answerComment5 === void 0 ? void 0 : (_answer$answerComment6 = _answer$answerComment5.comments) === null || _answer$answerComment6 === void 0 ? void 0 : _answer$answerComment6.map(function (comment) {
              return {
                id: comment.id.toString(),
                content: comment.content
              };
            })) || [],
            scrollable: true,
            labels: {
              comment: label.comment,
              seeMore: label.seeMore,
              seeLess: label.seeLess,
              teacherName: 'Teacher'
            }
          })
        })
      }), audioSource && /*#__PURE__*/_jsx(StyledAudioPlayerContainer, {
        children: /*#__PURE__*/_jsx(AudioPlayer, {
          source: audioSource
        })
      })]
    });
  };

  var renderHighlightGuide = function renderHighlightGuide() {
    if (!shouldShowHighlightGuide) {
      return null;
    }

    return /*#__PURE__*/_jsxs(StyledHighlightGuideBox, {
      children: [/*#__PURE__*/_jsx(StyledHighlightGuideHeaderRow, {
        children: /*#__PURE__*/_jsxs(StyledHighlightGuideTitleGroup, {
          children: [/*#__PURE__*/_jsx(InfoCircleOutlined, {}), /*#__PURE__*/_jsx(HighlightOutlined, {}), /*#__PURE__*/_jsx(StyledHighlightGuideTitleText, {
            children: label.highlightGuideTitle
          })]
        })
      }), /*#__PURE__*/_jsxs(StyledHighlightGuideStepList, {
        children: [label.highlightGuideStep1 && /*#__PURE__*/_jsx(StyledHighlightGuideStep, {
          children: label.highlightGuideStep1
        }), label.highlightGuideStep2 && /*#__PURE__*/_jsx(StyledHighlightGuideStep, {
          children: label.highlightGuideStep2
        }), label.highlightGuideStep3 && /*#__PURE__*/_jsx(StyledHighlightGuideStep, {
          children: label.highlightGuideStep3
        })]
      })]
    });
  };

  var wordCount = countWords(responderAnswerContent);
  var commentCount = shouldShowHighlightGuide ? (_comments$length = comments === null || comments === void 0 ? void 0 : comments.length) !== null && _comments$length !== void 0 ? _comments$length : savedComments.length : savedComments.length;
  return /*#__PURE__*/_jsx(BaseQuestionGradingComponent, {
    states: states,
    actions: actions,
    children: /*#__PURE__*/_jsxs(StyledSpaceContainer, {
      direction: "vertical",
      children: [renderHighlightGuide(), /*#__PURE__*/_jsxs(StyledStudentWorkHeader, {
        children: [/*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx(StyledSectionLabel, {
            children: label.studentWork
          }), shouldShowHighlightGuide && /*#__PURE__*/_jsxs("i", {
            children: [/*#__PURE__*/_jsx(HighlightOutlined, {}), label.selectTextToHighlight]
          })]
        }), /*#__PURE__*/_jsxs(StyledCountGroup, {
          children: [/*#__PURE__*/_jsxs(StyledCountBadge, {
            children: [wordCount, " ", label.words]
          }), /*#__PURE__*/_jsxs(StyledCountBadge, {
            children: [/*#__PURE__*/_jsx(MessageOutlined, {}), commentCount, " ", label.comment]
          })]
        })]
      }), renderAnswer()]
    })
  });
};